import { render, staticRenderFns } from "./pictureColumn.vue?vue&type=template&id=5c4121ba&scoped=true&"
import script from "./pictureColumn.vue?vue&type=script&lang=js&"
export * from "./pictureColumn.vue?vue&type=script&lang=js&"
import style0 from "./pictureColumn.vue?vue&type=style&index=0&id=5c4121ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4121ba",
  null
  
)

export default component.exports